import React from "react";
import ReactDOM from "react-dom";
import { DEFAULT_ANIMATION_SPEED } from "../../constants";
import { useGlobals } from "../../context/DesignSystemGlobals";

interface IMountTransition {
    open: boolean;
    mountElement?: Element | null;
    renderDelay?: number;
}

const MountTransition: React.FC<IMountTransition> = ({
    open,
    mountElement,
    renderDelay = DEFAULT_ANIMATION_SPEED,
    children
}) => {
    const [renderComponent, setRenderComponent] = React.useState<boolean>(open);
    const globals = useGlobals();

    React.useEffect(() => {
        let handler: number;

        open && !renderComponent && setRenderComponent(true);
        if (!open && renderComponent) {
            handler = window.setTimeout(() => setRenderComponent(false), renderDelay);
        }

        return () => clearTimeout(handler);
    }, [open]);

    return renderComponent
        ? ReactDOM.createPortal(children, mountElement ?? document.getElementById(globals.ROOT_ID)!)
        : null;
};

export default MountTransition;
